import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';

const baseCls = 'checkout-flight__airline';

const FlightsMobileAirline = ({ name, logo }) => {
  const { t } = useTranslation();
  return (
    <div className={baseCls}>
      {logo && (
        <div className={`${baseCls}-logo`}>
          <img src={logo.src} alt={name} title={name} />
        </div>
      )}
      {`${t('checkout.flight.airline.title')} ${
        name || t('checkout.flight.airline.unknown')
      }`}
    </div>
  );
};

FlightsMobileAirline.defaultProps = {
  name: null,
  logo: null,
};
FlightsMobileAirline.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.objectOf(PropTypes.string),
};

export default FlightsMobileAirline;
